import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { ColumnAlignment } from '@mews/b2b-ui';
import { asyncContainerFactory, ContentCard } from '@mews-commander/ui';
import { getPageFormatByServiceId } from '@mews-commander/legacy-entities/src/ducks/registrationCardConfigurations';
import { Table, TableWrapperElement } from '@mews-commander/ui/legacy';
import { getCheckedReservationIds } from '../../selectors';
import { areBalancesFetching } from '../../ducks/balances';
import ScanPassportButton from '../ScanPassportButton';
import PrintRegistrationCardsButton from '../PrintRegistrationCardsButton';
import ActionsButtons from './ActionsButtons';
import { getTableSource } from './selectors';

const mapping = [
    {
        title: <LocalizedText textKey={TextKey.Customer} />,
        valueKey: 'label',
    },
    {
        title: <LocalizedText textKey={TextKey.Balance} />,
        valueKey: 'balance',
    },
    {
        title: ' ',
        valueKey: 'actionsButtons',
        columnAlignment: ColumnAlignment.Right,
        render: ({ id, openItemCount }: $TSFixMe) =>
            id ? <ActionsButtons accountId={id} openItemCount={openItemCount} /> : null,
    },
];

const CustomersTable = ({ reservationIds, printSize, source }: $TSFixMe) => (
    <ContentCard
        title={<LocalizedText textKey={TextKey.CustomerPlural} />}
        actions={
            <>
                <ScanPassportButton text={TextKey.PassportScan} reservationIds={reservationIds} />
                <PrintRegistrationCardsButton
                    text={TextKey.RegistrationCards}
                    reservationIds={reservationIds}
                    printSize={printSize}
                />
            </>
        }
    >
        <TableWrapperElement>
            <Table mapping={mapping} source={source} />
        </TableWrapperElement>
    </ContentCard>
);

export default compose(
    connect(
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        createStructuredSelector({
            isFetching: areBalancesFetching,
            source: getTableSource,
            reservationIds: getCheckedReservationIds,
            printSize: getPageFormatByServiceId,
        })
    ),
    asyncContainerFactory({ withOverlayedLoader: true })
)(CustomersTable);
